import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="846693188866-nbsfvk6k3dolcsvusgjgo6mda8t32ucf.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);

